import { z } from 'zod'

export const AddShippingMethodForCartSchema = z.object({
    cart_id: z.string().min(1),
    shipping_method_id: z.string().min(1),
    data: z.any().optional(),
})
